import dayjs from "dayjs";

import { EMPTY_TEXT, formattedPrice } from "../../../../../shared/utils";

export const HEADERS_PAYMENT_METHOD = [
    {
      title: 'Forma de Pago',
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
    },
    {
      title: 'Monto Exacto ($)',
      dataIndex: 'exactAmount',
      key: 'exactAmount',
      render: (amount: string) =>  amount ? <span>{`$ ${formattedPrice(amount)}`}</span> : EMPTY_TEXT
    },
    {
      title: 'Banco',
      dataIndex: 'bank',
      key: 'bank',
      render: (bank: string) => bank ? bank : EMPTY_TEXT,
    },
    {
      title: 'Fecha de Transferencia',
      dataIndex: 'transferDate',
      key: 'transferDate',
      render: (date: string) =>  date ? <span>{dayjs(date).format('DD/MM/YYYY')}</span> : EMPTY_TEXT
    },
    {
      title: 'Fecha del Cheque',
      dataIndex: 'checkDate',
      key: 'checkDate',
      render: (date: string) => date ? <span>{dayjs(date).format('DD/MM/YYYY')}</span> : EMPTY_TEXT
    },
    {
      title: 'Número de Cheque',
      dataIndex: 'checkNumber',
      key: 'checkNumber',
      render: (checkNumber: string) => checkNumber ? checkNumber : EMPTY_TEXT 
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      render: (observations: string) => observations ? observations : EMPTY_TEXT 
    },
    {
      title: 'Comprobante de Pago',
      dataIndex: 'proofOfPayment',
      width: '13%',
      key: 'proofOfPayment',
      render: (proofOfPayment: string) => proofOfPayment ? proofOfPayment : EMPTY_TEXT 
    },
    {
      title: 'Acción',
      dataIndex: 'action',
      width: '5%',
      key: 'action',
    },
  ];